const configs = {
    linkaiAdmin: ['', 'owners', 'Kalendorius', 'Vartotojai'],//nekeisti
    linkaiAdminText: ['Gyvūnai', 'Savininkai', 'Kalendorius', 'Darbuotojai'],
    linkaiNeAdmin: ['', 'owners', 'Kalendorius'],//nekeisti
    linkaiNeAdminText: ['Gyvūnai', 'Savininkai', 'Kalendorius'],
}

const basic = {
    "amziusLabel": "Amžius",
    "ExportTable": "lentelė",
    "arIstrintProfili": "Ar tikrai norite ištrinti įmonės profilį?",
    "filtruoti": "Filtruoti",
    "imones_label": "Įmonės",
    "imones_pav": "Įmonės pavadinimas",
    "issaugoti": "Išsaugoti",
    "iveskiteImone": "Įveskite įmonės pavadinimą",
    'iveskiteImoneMin': 'Neteisingas įmonės pavadinimas',
    "iveskitePass": "Slaptažodį turi sudaryti mažiausiai 6 simboliai",
    "ivestiName": "Įveskite vardą ir pavardę",
    "kopijuoti": "Kopijuoti",
    "kopijuoti_nuoroda": "Kopijuoti nuorodą",
    "laikaiLabel": "Kiek laiko dirba",
    "laukia_patvirtinimo": "Laukia patvirtinimo",
    "login_email": "El. paštas",
    "login_pass": "Slaptažodis",
    "login_pass_pakartot": "Pakartoti slaptažodį",
    "lytysLabel": "Lytis",
    "ne": "Ne",
    "nebegalioja": "Nebegalioja",
    "nepatvirtinta": "Nepatvirtinta",
    "neteisingasEmail": "Neteisingas el. paštas",
    "neteisingasTel": "Neteisingas tel. nr. (+...)",
    "neteisingiDuomenys": "Neteisingi prisijungimo duomenys",
    "new_login_pass": "Naujas slaptažodis",
    "padetysLabel": "Šeimyninė padėtis",
    "pamirsai_pass": "Pamiršai slaptažodį?",
    "pareigomsLabel": "Pareigos įmonėje",
    "patvirtinta": "Patvirtinta",
    "patvirtinti_reg": "Patvirtinti registraciją",
    "perziureti_rezultatus": "Paciento koretelė",
    "pildytojuTipaiLabel": "Pasirinkti",
    "prenumeratos_label": "Prenumeratos galiojimo data",
    "prisijungti": "Prisijungti",
    "prisiminti": "Priminti",
    "profilio_redagavimas": "Profilio redagavimas",
    "profilis": "Profilis",
    "redaguoti": "Redaguoti",
    "registruoti": "Registruoti",
    "registruotis": "Registruotis",
    "rodoma": "Rodoma:",
    "sekminga_reg": "Registracija sėkminga!",
    "sekminga_reg_txt1": "Jūsų profilį aktyvuosime arba su Jumis susisieksime per 3 darbo dienas. Kilus klausimams kviečiame mums parašyti el. paštu diversity@diversity.lt",
    "slaptazodzio_priminimas": "Slaptažodžio priminimas",
    "slaptazodzio_priminimas_txt": "Norėdami prisiminti slaptažodį, įveskite el. pašto adresą, kurį naudojate prisijungimui",
    "statusas_label": "Statusas",
    "sukurti_apklausa": "Skurti apklausą",
    "sukurti_imone": "Įmonės registracija",
    "susipazinau_su_taisyklem": "Susipažinau su privatumo politika ir taisyklėmis",
    "taip": "Taip",
    "telNr": "Tel. Nr.",
    "tipas_label": "Formos rūšis",
    "trinti": "Ištrinti",
    "priminimasIvyko": "Nuoroda slaptažodžio atkūrimui išsiųsta",
    "slaptazodisPakeistas": "Slaptažodis pakeistas",
    "accComfirmedError": "Vartotojas nepatvirtintas",
    "atgal": "Atgal",
    "create_imone": "Sukurti darbuotoją",
    "darbuotojai": "Darbuotojai",
    "grizti_i_vartotojus": "Grįžti į sąrašą",
    "kopijuoti_logotipa": "Kopijuoti logotipą",
    "kopijuoti_pdf_fona": "Kopijuoti PDF foną",
    "naujas_vartotojas": "Naujas darbuotojas",
    "sukurti_is_mano_duomenu": "Sukurti iš mano duomenų",
    "sukurti_kita": "Sukurti kitą",
    "sukurti_tuscia": "Sukurti tuščią",
    "username_klaida": "Įveskite naudotojo vardą (min. 3 simboliai)",
    "username_label": "Naudotojo vardas",
    "vartotojas_sukurtas": "Darbuotojas sėkmingai sukurtas!",

}

export const lt = {

    translations: {
        ...basic,
        ...configs,
        seniDarbai: 'Seni darbai',
        VisitDate:'Vizito data',
        pratesti: 'Pratęsti',
        waitingForServer: 'Laukiama serverio atsakymo...',
        priskirtiSeimininkaVartotojui: 'Priskirti šeimininką',
        "vet-helper-into-text": "App",
        "types": ["Osteopatija", 'Kinezioteipavimas', 'Radijo dažnio bangų terapija', 'Veterinaro apsilankymas'],
        "typesLabel": "Gydymo tipas",
        Redaguoti_paciento_kortele: 'Šeimininko kortele',
        pacientai: 'Pacientai',
        'AnimalGender-Basic': ['Patelė', 'Patinas'],
        'AnimalGender-Horse': ['Kastratas', 'Eržilas', 'Kumelė'],
        'AnimalGender': {
            Horse: ['Kastratas', 'Eržilas', 'Kumelė'],
            Basic: ['Male', 'Female'],
        },
        Horse: 'Arklys',
        Gelding: 'Kumelė',
        AnimalTypes: ['Arklys', '-'],
        AnimalTypesLabel: "Gyvūno Tipas",
        animal_age: 'Amžius',
        animal_name: 'Vardas',
        AnimalGenderLabel: 'Lytis',
        owner: 'Savininkas',
        pacientas: 'Pacientas',
        //kalbos
        kalba_text: ['LT', 'EN', 'RU'],
        kalba: ['lt', 'en', 'ru'],
        Nera_ats: '-',
        pp: 'Privatumo politika',
        pt: 'Paslaugų teikimo taisyklės',
        contacts: 'Contacts',
        email: 'Email: ',
        tel: 'Tel: ',
        adress: 'Adress: ',
        animals: 'Gyvūnai',
        Animal_Info: 'Animal info',
        createOwner: 'Sukurti naują savininką',
        createOwnerText: 'Sukurkite naują savininką, užpildydami žemiau esančią formą',
        editOwnerText: 'Redaguokite savininko kortelę, užpildydami žemiau esančią formą',
        createPatient: 'Sukurti naują pacientą',
        createPatientText: 'Sukurkite naują pacientą, užpildydami žemiau esančią formą',
        editPatientText: 'Redaguokite paciento kortelę, užpildydami žemiau esančią formą',
        Naujo_savininko_kortele: 'Naujo savininko kortelė',
        Naujo_paciento_kortele: 'Naujo paciento kortelė',
        Redaguoti_savininko_kortele: 'Redaguoti savininko kortelę',
        imones_kodas: 'Įmonės kodas',
        imones_pvm: 'Įmonės PVM',
        imones_adresas: 'Įmonės adresas',
        ar_tikrai_norite_istrinti: 'Ar tikrai norite ištrinti?',
        ar_tikrai_istrinti_savininka: 'Ar tikrai norite ištrinti savininką? Jo pacientai liks sistemoje.',
        ar_tikrai_istrinti_pacienta: 'Ar tikrai norite ištrinti pacientą?',
        ar_tikrai_norite_sukutri_nauja: 'Ar tikrai norite sukurti naują vizitą?',
        update: 'Atnaujinti',
        info: 'Info',
        stasis: 'Stazė',
        exports: 'Eksportas',
        Visit: 'Vizitas',
        images: 'Nuotraukos',
        'pdf-background': 'PDF fonas',
        'pdf_Open': 'Atidaryti PDF',
        'pdf_resize': 'Keisti dydį',
        'pdf_atsisiusti': 'Atsisiųsti PDF',
        'pdf_ruosiamas': 'Ruošiamos nuotraukos...',
        'pdf_ios_info': '„iPhone“ ir „iPad“ naršyklė peržiūroje parodo tik pirmą puslapį, todėl spauskite „Atidaryti PDF“ – dokumentas atsidarys visas, su galimybe išsaugoti ar persiųsti.',
        be_vardo: 'Be vardo',
        atnaujinti: 'Atnaujinti',
        issaugoti: 'Išsaugoti',
        vardas_pavarde: 'Vardas, pavardė',
        vardas: 'Vardas',
        name: 'Vardas',
        surname: 'Pavardė',
        address: 'Adresas',
        gydytojas: 'Gydytojas',
        Gydymas: 'Gydymas',
        Nuotraukos: 'Nuotraukos',
        filter: 'Filtras',
        atnaujinti_sarasa: 'Atnaujinti sąrašą',
        ikelti_nuotrauka: 'Įkelti nuotrauką',
        pakeisti_nuotrauka: 'Pakeisti nuotrauką',
    }
}
